import * as React from 'react';
import { Button } from 'antd';
import * as classnames from 'classnames';

import './Button.less';

interface Props {
  className?: string;
  type?: 'primary' | 'default' | 'ghost' | 'dashed' | 'danger';
  htmlType?: undefined | 'button' | 'submit' | 'reset';
  size?: 'large' | 'small' | '';
  onClick?: (evt: any) => void;
  round?: boolean;
  icon?: string;
  loading?: boolean;
  disable?: boolean;
}

class ButtonWrapper extends React.PureComponent<Props> {
  static defaultProps = {
    className: '',
    onClick: () => null,
    type: 'default',
    size: '',
    round: false,
    htmlType: 'button',
    icon: '',
    loading: false,
    disable: false,
  };

  render() {
    const {
      children,
      className,
      onClick,
      type,
      size,
      round,
      htmlType,
      icon,
      loading,
      disable,
    } = this.props;
    const classNameSize = `bc-button-${size}`;
    const clsName = classnames(
      'bc-button',
      className,
      `bc-button-${type}`,
      { [classNameSize]: !!size },
      { 'bc-button-round': round },
    );
    return (
      <Button
        className={clsName}
        onClick={onClick}
        htmlType={htmlType}
        type={type}
        icon={icon}
        loading={loading}
        disabled={disable}
      >
        {children}
      </Button>
    );
  }
}

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./src/components/Button/Button.tsx